// NOTES
// - super simple display only panel for SSH Keys

import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header, Icon } from "semantic-ui-react";

import LinkWithReset from "../utils/LinkWithReset.jsx";

import { ROUTES } from "../../constants/routing.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectSSHPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "project_settings.ssh_panel"
  };

  renderKeyLinks = () => {
    const { data } = this.props;

    return data.map(item => {
      return (
        <LinkWithReset
          to={ROUTES.SSH_KEYS}
          style={{ marginRight: "2em" }}
          key={item["@id"]}
        >
          <Icon name="key" />
          {item.name}
        </LinkWithReset>
      );
    });
  };

  render() {
    const { data, disabled, copyKey, copy } = this.props;

    const bodyKey = data && data.length > 0 ? "body" : "no_keys";

    return (
      <Segment className="clear-both" disabled={disabled}>
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        <p>{copy(`${copyKey}.${bodyKey}`)}</p>
        <p>{this.renderKeyLinks()}</p>
        <p>{copy(`${copyKey}.restriction_message`)}</p>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectSSHPanel);
